<template>
  <div class="Mechanism">
    <ApplySlotGroup @saveData="saveData">
      <div class="Mechanism-top">
        <el-checkbox @change="workTypeChange" label="1">我是办事处</el-checkbox>
        <el-form class="Form-style">
          <el-form-item class="Company-name" label="公司名称">
            <el-autocomplete style="width: 100%;" v-model="dataForm.mechanismName" placeholder="请输入公司名称" :fetch-suggestions="querySearchCompany" @select="handleSelectCompany">
              <template slot-scope="scope">
                <div>{{scope.item.name}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item label="注册国家">
            <el-autocomplete style="width: 100%;" v-model="dataForm.countryRegistration" placeholder="请输入注册国家" :fetch-suggestions="querySearchCountryRegistration" @select="handleSelectCountryRegistration">
              <template slot-scope="scope">
                <div>{{scope.item.countryNameCn}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item label="注册城市">
            <el-autocomplete style="width: 100%;" v-model="dataForm.cityRegistration" placeholder="请输入注册城市" :fetch-suggestions="querySearchCityRegistration" @select="handleSelectCityRegistration">
              <template slot-scope="scope">
                <div>{{scope.item.cityNameCn}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item label="公司类型">
            <el-select v-model="dataForm.companyType" placeholder="请选择公司类型">
              <el-option v-for="item in companyTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="经营范围">
            <el-input v-model="dataForm.natureBusiness" placeholder="请输入公司经营范围"></el-input>
          </el-form-item>

          <el-form-item label="注册地址">
            <el-input v-model="dataForm.adressRegistration" placeholder="请输入公司注册地址"></el-input>
          </el-form-item>

          <el-form-item v-if="dataForm.workType === 1" label="注册国家（办事处）">
            <el-autocomplete style="width: 100%;" v-model="dataForm.countryWork" placeholder="请输入注册国家" :fetch-suggestions="querySearchCountryWork" @select="handleSelectCountryWork">
              <template slot-scope="scope">
                <div>{{scope.item.countryNameCn}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item v-if="dataForm.workType === 1" label="注册城市（办事处）">
            <el-autocomplete style="width: 100%;" v-model="dataForm.cityWork" placeholder="请输入注册城市" :fetch-suggestions="querySearchCityWork" @select="handleSelectCityWork">
              <template slot-scope="scope">
                <div>{{scope.item.cityNameCn}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item v-if="dataForm.workType === 1" label="注册地址（办事处）">
            <el-input v-model="dataForm.adressWork" placeholder="请输入注册地址"></el-input>
          </el-form-item>

          <el-form-item label="公司营业执照有效期">
            <el-date-picker v-model="dataArr" type="daterange" range-separator="-" @change="dataChange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item style="flex-direction: column;padding-bottom: 15px;" label="公司营业执照">
            <wintac-upload imgName="营业执照" :pid="pid" :state="0" env="user">
            </wintac-upload>
          </el-form-item>

          <el-form-item class="Company-introduction" label="公司简介">
            <el-input style="width: 9rem;" type="textarea" v-model="dataForm.introduce" :rows="5" placeholder="请填写公司简介"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="supplier-checkTabs">
        <span @click="changeTabs(1)" :class="checkTabs === 1 ? 'checkTabs-isActive' : ''">业务联系人</span>
        <span @click="changeTabs(2)" :class="checkTabs === 2 ? 'checkTabs-isActive' : ''">收款账户</span>
        <span @click="changeTabs(3)" :class="checkTabs === 3 ? 'checkTabs-isActive' : ''">法人信息</span>
        <span @click="changeTabs(4)" :class="checkTabs === 4 ? 'checkTabs-isActive' : ''">信息设置</span>
      </div>

      <!-- 业务联系人 -->
      <businessContact v-show="checkTabs==1"></businessContact>
      <!--收款账户-->
      <collection v-show="checkTabs==2" :supplierType="0"></collection>
      <!-- 法人信息 -->
      <legalInfo v-show="checkTabs==3"></legalInfo>
      <!-- 供应商自动接收信息设置 -->
      <automatic v-show="checkTabs==4"></automatic>
      <!-- 接单区域选择 -->
      <AreaSelect></AreaSelect>
    </ApplySlotGroup>

    <el-dialog class="productTypeDialog" title="入驻审核提示" custom-class="customProduct" :visible.sync="applyShow" width="30%">
      <div class="dialog-top">
        <span>入驻审核提示</span>
      </div>
      <div class="applets-style">
        <p>亲，你的<b>申请已经提交</b>，我们将在24小时内审核，请您<b>关注下方二维码</b>，
          在“实用工具'-"地接圈 账户绑定”内将您的微信和供应商账号绑定，
          您将可以及时在线收到审核结果。您也可用您的手机号及密码登录此后台查看审核结果。
          若您急需尽快开始使用供应商后台，请您致电我们的紧急 <b>服务电话 15001256336</b>与我们联系，
          我们将走特殊审批渠道为您尽快开通账号。
        </p>
        <div style="text-align: center;padding-top: 30px;">
          <img src="@/assets/png/公众号.png" alt="">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import businessContact from '@/views/mechanism/components/SettleFlod/Child/BusinessContact.vue'
  import collection from '@/views/mechanism/components/SettleFlod/Child/Collection'
  import legalInfo from '@/views/mechanism/components/SettleFlod/Child/LegalInfo'
  import automatic from '@/views/mechanism/components/SettleFlod/Child/Automatic'
  import AreaSelect from '@/views/mechanism/components/SettleFlod/Child/AreaSelect'
  import { mapState } from 'vuex'
  import Api from '@/components/Api/index'
  import ApplySlotGroup from '@/components/Apply-Slot-Group'
  export default {
    name: '',
    components: {
      businessContact,
      collection,
      legalInfo,
      automatic,
      ApplySlotGroup,
      AreaSelect
    },
    // 定义属性
    data() {
      return {
        pid: '',
        checkTabs: 1,
        office: false,
        applyShow: false,
        dataArr: '',
        dataForm: {
          workType: 0, //0 非办事处 1 办事处
          mechanismName: '', //公司名称
          mechanismAbb: '', //公司简称
          countryRegistration: '', //注册国家
          countryIdRegistration: '', //注册国家ID
          cityRegistration: '', //注册城市
          cityIdRegistration: '', //注册城市ID
          countryWork: '', //办事处国家
          countryIdWork: '', //办事处国家ID
          cityWork: '', //办事处城市
          cityIdWork: '', //办事处城市ID
          companyType: '', //公司类型 1、有限责任公司;2、股份有限公司;3、合伙企业;4、个人独资企业;5、农民专业合作社
          natureBusiness: '', //经营范围
          adressRegistration: '', //注册地址
          adressWork: '', //办事处地址
          startTime: '', //开始日期
          endTime: '', //结束日期
          introduce: '', //公司介绍
          logo: '', //企业头像
        },

        companyTypeText: {
          '1': '有限责任公司',
          '2': '股份有限公司',
          '3': '合伙企业',
          '4': '个人独资企业',
          '5': '农民专业合作社'
        },
        companyTypeOptions: [
        {
          value: 1,
          label: '有限责任公司'
        },
        {
          value: 2,
          label: '股份有限公司'
        },
        {
          value: 3,
          label: '合伙企业'
        },
        {
          value: 4,
          label: '个人独资企业'
        },
        {
          value: 5,
          label: '农民专业合作社'
        }],
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapState(['supplierBasics'])
    },
    // 监控data中的数据变化
    watch: {
      'dataForm.countryRegistration': {
        handler(value) {
          if (value === '') {
            this.dataForm.countryIdRegistration = null
          }
        }
      },
      'dataForm.countryWork': {
        handler(value) {
          if (value === '') {
            this.dataForm.countryIdWork = null
          }
        }
      },
      'dataForm': {
        handler(value) {
          this.$store.commit('setMechanismSupplier', value)
        },
        deep: true
      },
      'supplierBasics': {
        handler(value) {
            console.log('dahhhh',value)
            
          this.dataForm = value.mechanismSupplier
          this.pid = this.dataForm.id
          this.dataArr = [value.mechanismSupplier.startTime, value.mechanismSupplier.endTime]
        },
        deep: true
      }
    },
    // 方法集合
    methods: {
      _getCustomizerInfoData(companyId) {
        new Api('user').getCustomizerInfo(companyId).then(res => {
            if(res.status == 200){
                console.log('jsdhfkdsf',res.data)
                
                this.$store.commit('setSupplierBasics',res.data)
            }
        })
      }, 
      saveData(_data) {
        this.$store.dispatch('savePlatSupplierData', {
          success: (pid) => {
            _data.applyCallback(pid).then(res => {
              if (res == 1) {
                this.applyShow = res
              } else {
                this.$message.success('success')
              }
              this._getCustomizerInfoData()
            })
          },
          fail: (_message) => {
            this.$message.error(_message)
          }
        })
      },
      querySearchCompany(queryString, cb) {
        var companyList = []
        new Api('user').tianyanQueryList({ key: queryString }).then(res => {
          if (res.status == 200) {
            companyList = res.data;
            cb(companyList);
          } else {
            this.$message.error({ message: res.statusText })
          }
        })
      },
      handleSelectCompany(item) {
        this.dataForm.mechanismName = item.name
        new Api('user').tianyanQuery({ key: item.name }).then(res => {
          if (res.status == 200) {
            for (const key in this.dataForm) {
              if (key !== 'cityRegistration' && key !== 'companyType') {
                this.dataForm[key] = res.data[key]
              }
            }
            this.$store.state.tianyanchaQueryData = res.data
            this.dataArr = [this.dataForm.startTime, this.dataForm.endTime]
          }
        })
      },
      workTypeChange(e) {
        if (e) this.dataForm.workType = 1
        else this.dataForm.workType = 0

      },
      dataChange(e) {
        console.log("选中时间", e, this.dataArr)
        this.dataForm.startTime = e[0]
        this.dataForm.endTime = e[1]
      },
      changeTabs(p) {
        this.checkTabs = p
      },
      querySearchCountryRegistration(queryString, cb) {
        var restaurants;
        new Api('resource').countryList({
          countryName: queryString,
        }).then(res => {
          if (res.status == 200) {
            restaurants = res.data;
            cb(restaurants);
          } else {
            this.$message.error({ message: res.statusText })
          }
        })
      },
      handleSelectCountryRegistration(item) {
        this.dataForm.countryIdRegistration = item.id
        this.dataForm.countryRegistration = item.countryNameCn
      },
      querySearchCityRegistration(queryString, cb) {
        var restaurants;
        new Api('resource').cityList({
          countryId: this.dataForm.countryIdRegistration,
          cityName: queryString || '',
        }).then(res => {
          if (res.status == 200) {
            restaurants = res.data;
            cb(restaurants);
          } else {
            this.$message.error({ message: res.statusText })
          }
        })
      },
      handleSelectCityRegistration(item) {
        this.dataForm.cityIdRegistration = item.id
        this.dataForm.cityRegistration = item.cityNameCn;
        this.dataForm.countryIdRegistration = item.countryId
        this.dataForm.countryRegistration = item.countryNameCn
      },

      querySearchCountryWork(queryString, cb) {
        var restaurants;
        new ResourceApi('resource').countryList({
          countryName: queryString,
        }).then(res => {
          if (res.status == 200) {
            restaurants = res.data;
            cb(restaurants);
          } else {
            this.$message.error({ message: res.statusText })
          }
        })
      },
      handleSelectCountryWork(item) {
        this.dataForm.countryIdWork = item.id
        this.dataForm.countryWork = item.countryNameCn
      },
      querySearchCityWork(queryString, cb) {
        var restaurants;
        new ResourceApi('resource').cityList({
          countryId: this.dataForm.countryIdRegistration,
          cityName: queryString,
        }).then(res => {
          if (res.status == 200) {
            restaurants = res.data;
            cb(restaurants);
          } else {
            this.$message.error({ message: res.statusText })
          }
        })
      },
      handleSelectCityWork(item) {
        this.dataForm.cityIdWork = item.id
        this.dataForm.cityWork = item.cityNameCn;
        this.dataForm.countryIdWork = item.countryId
        this.dataForm.countryWork = item.countryNameCn
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this._getCustomizerInfoData()
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style scoped lang="scss">
  /deep/ .el-form-item__content {
    width: 6rem;
  }

  .Mechanism {
    //width: 12.8rem;
    margin: 0 auto;

    .Mechanism-top {
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
      border-radius: 6px 6px 6px 6px;
      background-color: rgba(255, 255, 255, 1);
      margin: 15px auto;
      //width: 12.8rem;

      /deep/.el-checkbox {
        padding-left: 30px;
        padding-top: 10px;
      }
    }

    .Form-style {
      padding: 30px;
      //width: 12.8rem;
      padding-top: 20px;
    }

    .Form-style /deep/.el-input__inner {
      border: none;
      background: none;
      border-radius: 0 !important;
      padding-left: 0;
      font-size: 14px;
      font-family: PingFangSC-light;
    }

    .Form-style /deep/.el-form-item__label {
      font-size: 14px;
      border-radius: 0 !important;
      padding-right: 150px;
      font-family: PingFangSC-light;
      width: 5rem;
      text-align: left;
    }

    .Form-style /deep/.el-form-item {
      display: flex;
      border-bottom: 1.3px dashed rgba(242, 237, 237, 1);
    }

    .Company-name /deep/.el-form-item__label {
      color: #E54E17;
    }

    .Company-introduction {
      display: block !important;
      border-bottom: none !important;
    }
  }

  .supplier-checkTabs {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    position: relative;
    z-index: 1009;

    >span {
      display: inline-flex;
      min-width: 180px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 30px;
      padding-right: 30px;
      border: 1px solid #ddd;
      justify-content: center;
      margin-left: 5px;
      margin-right: 5px;
      border-radius: 5px;
    }

    .checkTabs-isActive {
      color: white;
      background-color: var(--color);
      opacity: 0.7;
      border: none;
    }
  }
</style>